class gTagEvents {
    constructor() {
        this.delegateBody = new Delegate(document.body);
        
        this.bindEvents();
        this.observeDOMChanges();
        this.handleIntersects();

        this.interceptCartApi();
    }

    bindEvents() {
        this.delegateBody.on("click", "button[name='checkout']", this.handleCheckout.bind(this));
        this.delegateBody.on("click", '[data-action="ga-send-select"]', this.handleSelectItem.bind(this));
        this.delegateBody.on('variant:changed:gtm', this.handleVariantChange.bind(this));
        this.delegateBody.on("click", '[data-toggle-id="pm-size-guide"], [data-toggle-id="pm-lens-guide"], [data-toggle-id="pm-strength-guide"]', this.handleGuideClick.bind(this));
        this.delegateBody.on("click", '.cart-drawer__product-image--wrapper .product-card__image', this.handleCartUpsellImageClick.bind(this));
        this.delegateBody.on("click", '.pc__instant-atc[data-toggle-id="quick-add-drawer"]', this.handleCartUpsellAddToCart.bind(this));

        document.addEventListener("collection:filter:applied", this.handleFilterApplied.bind(this));

        document.addEventListener("DOMContentLoaded", this.setTrackingConsentCookie.bind(this));
    }

    setTrackingConsentCookie() { 
        const existingCookie = document.cookie.split(';').find(c => c.trim().startsWith('_tracking_consent'));
        if (existingCookie) {
            console.log('[CONSENT] Cookie already exists');
            return;
        }
        
        const updateCookie = (detail) => {     
            if (!detail) {
                console.log('[CONSENT] No detail - aborting');
                return;
            }
            
            const functional = detail.preferencesAllowed;
            const analytics = detail.analyticsAllowed;
            const marketing = detail.marketingAllowed;
            
            let flag = '0';
            flag += functional ? 'F' : 'f';
            flag += analytics ? 'A' : 'a';
            flag += marketing ? 'M' : 'm';
            
            const cookieValue = `${flag}.0`;
            const expires = new Date();
            expires.setFullYear(expires.getFullYear() + 1);
            const cookieString = `_tracking_consent=${cookieValue}; path=/; SameSite=Lax; Secure; expires=${expires.toUTCString()}`;
            
            document.cookie = cookieString;
        };
        
        if (window.Shopify?.customerPrivacy?.currentVisitorConsent()) {
            updateCookie(window.Shopify.customerPrivacy.currentVisitorConsent());
        }
        
        document.addEventListener('visitorConsentCollected', (event) => {
            updateCookie(event.detail);
        });
    }

    observeDOMChanges() {
        const observer = new MutationObserver((mutationsList, observer) => {
            // For each mutation record, we look for added nodes
            for (const mutation of mutationsList) {
                if (mutation.addedNodes.length) {
                    // If there are added nodes, we call handleIntersects to check for new items
                    this.handleIntersects();
                }
            }
        });

        // Start observing the document body for added nodes and subtree modifications
        observer.observe(document.body, {
            childList: true, // Observe direct children
            subtree: true, // and all descendants
            attributes: false // Set to true if you also want to observe attribute changes
        });
    }

    handleIntersects() {
        const allIntersections = document.body.querySelectorAll('[data-gtag-intersection][data-observed="false"]');

        allIntersections.forEach((item) => {
            const observer = new IntersectionObserver(
                this.handleIntersection.bind(this),
                {
                    root: null, // Use the viewport as the root
                    rootMargin: "0px",
                    threshold: 0.1, // Adjust the threshold as per your requirement
                }
            );

            observer.observe(item);
            item.dataset.observed = "true";
        });
    }

    handleIntersection(entries) {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                let data = false;

                try {
                    data = JSON.parse(
                        entry.target.querySelector('script[type="application/ld+json"]').textContent
                    );

                } catch (e) {
                    console.log("JSON parse failed", e);
                }

                if (!dataLayer || !data) return;

                if (entry.target.classList.contains('shop-the-look-gtm')) {
                    // find items in the section and add them to data

                    const itemScripts = entry.target.parentElement.querySelectorAll('.view-item-helper');
                    console.log(entry.target.parentElement);
                    
                    console.log(itemScripts);
                }

                dataLayer.push({ ecommerce: null });
                dataLayer.push(data);

                console.log(data, "And pushed to dataLayer");
            }
        });
    }

    // check if okay
    // how we fetch current variant can vary depending on the theme
    handleVariantChange(event) {        
        // get current variant id from url
        const params = new URLSearchParams(window.location.search);
        const variantIdParam = params.get("variant");
    
        if (!variantIdParam) return;
        const currentVariantID = Number(variantIdParam);
    
        // find current variant json in ShopifyAnalytics
        const variants = ShopifyAnalytics.meta.product.variants;
        let currentVariant = null;
    
        variants.forEach(variant => {        
            if (variant.id === currentVariantID) currentVariant = variant;
        })
    
        // get and update gtm script
        const dataElem = document.querySelector('.main-product__gtm-script');    
        if (!currentVariant || !dataElem) return;
        
        const data = JSON.parse(dataElem.textContent);
        const item = data.ecommerce.items[0];
        
        item.item_variant = currentVariant.public_title || "Default Title";
        item.item_id = currentVariant.id || "";
        item.item_sku = currentVariant.sku || "";
        item.price = currentVariant.price / 100;
        item.quantity = 1;
    
        data.ecommerce.value = currentVariant.price / 100;
    
        if (!dataLayer || !data) return;
    
        dataLayer.push({ ecommerce: null });
        dataLayer.push(data);
        console.log(data, "And pushed to dataLayer");
    }

    interceptCartApi() {
        const originalFetch = window.fetch;
        const _this = this;

        window.fetch = async function (...args) {
            try {
                const [url, request] = [...args];

                // Trigger custom logic for cart clear API
                if (url.includes(`/cart/clear`)) _this.cartClear();
                if (url.includes(`/cart/update`)) _this.cartUpdate(request.body);

                const response = await originalFetch.apply(this, args);
                if (!response.ok) return response;
                
                 // Early return for non-cart-related APIs or missing conditions
                 if (url === '' || !dataLayer) return response;             

                // Process cart actions based on URL
                if (url.includes(`/cart/add`)) {
                    const responseClone = response.clone();
                    const json = await responseClone.json(); 

                    _this.cartAdd(json, request);
                } else if (url.includes(`/cart/change`)) {
                    const responseClone = response.clone();
                    const json = await responseClone.json(); 

                    _this.cartChange(json);
                }

                return response;

            } catch (e) {
                console.error('Fetch interceptor error:', e);
                return originalFetch(...args);
            }
        };
    }

    // check if quantity is okay
    // when adding product that already exist in a cart fetch response thats returned does not have right product quantity
    // instead of showing how many products has been added it shows how many there are in cart
    async cartAdd(cart, request) {
        let cartItems = cart.items ? cart.items : [cart];
        cartItems = this.getDataFromRequest(cartItems, request);
        this.productAdded(cartItems);
    }

    async cartUpdate(body) {
        if (!body) return;
        const updates = JSON.parse(body).updates;
    
        const oldCart = await this.getCart();
        const cartItems = oldCart.items, itemsAdded = [], itemsRemoved = [];
    
        cartItems.forEach(item => {            
            const newQuantity = updates[item.key];
            if (typeof newQuantity === "number") {
                const change = newQuantity - item.quantity;
                item.quantity = Math.abs(change);
    
                change < 1 ? itemsRemoved.push(item) : itemsAdded.push(item);
            }
        })
    
        this.productAdded(itemsAdded);
        this.productsRemoved(itemsRemoved);
    }

    async cartChange(cart) {
        this.productAdded(cart.items_added);
        this.productsRemoved(cart.items_removed);
    }

    async cartClear() {
        const cart = await this.getCart();
        this.productsRemoved(cart.items);
    }

    async getCart() {
        try {
            const response = await fetch(window.routes.localeRootUrl + "/cart.js", {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "X-Requested-With": "XMLHttpRequest",
                },
            });

            return await response.json();

        } catch (error) {
            console.log('Fetch Error:', error);
        }
    }

    productAdded(cartItems) {
        if (!cartItems || !cartItems.length) return;

        const customEvent = {
            'event': 'custom_add_to_cart',
            'ecommerce': this.buildEcommerce(cartItems)
        }

        dataLayer.push({ ecommerce: null });
        dataLayer.push(customEvent);
        console.log("dataLayer push -> custom_add_to_cart:", customEvent);
    }

    async productsRemoved(cartItems) {
        if (!cartItems || !cartItems.length) return;

        const customEvent = {
              'event': "custom_remove_from_cart",
              'ecommerce': this.buildEcommerce(cartItems)
        }
  
        dataLayer.push({ ecommerce: null });
        dataLayer.push(customEvent);
        console.log("dataLayer push -> custom_remove_from_cart:", customEvent);
    }

    handleCheckout() {
        const button = event.target.closest("button[name='checkout']");
        if (!button) return;

        const script = button.parentElement.querySelector('[type="application/ld+json"]');
        const settings = JSON.parse(script.innerText);

        if (!dataLayer || !settings) return;

        dataLayer.push({ ecommerce: null });
        dataLayer.push(settings);

        console.log("dataLayer push -> checkoutFired:", settings);
    }

    handleSelectItem(event) {
        let target = event.target.closest('[data-action="ga-send-select"]');
        if (!target || !dataLayer) return;

        const settings = JSON.parse(target.dataset.selectSettings);
        if (!settings) return;

        const customEvent = {
            event: "custom_select_item",
            ecommerce: {
                selected_item_list_id: settings.list_id,
                selected_item_list_name: settings.list_name,
                currency: ShopifyAnalytics.meta.currency,
                items: [settings]
            }
        }

        dataLayer.push({ ecommerce: null });
        dataLayer.push(customEvent);
        console.log("dataLayer push -> custom_select_item:", customEvent);
    }

    handleFilterApplied(event) {
        if (!dataLayer) return;

        const { filterType, filterData, activeFilters, resultsCount } = event.detail || {};

        // Convert activeFilters object to array of strings for GA4
        const filtersArray = [];

        if (activeFilters && typeof activeFilters === 'object') {
            Object.keys(activeFilters).forEach(filterKey => {
                // Extract readable filter name from key (e.g., "filter.p.m.custom.color_image" -> "color_image")
                const filterNameMatch = filterKey.match(/\.([^.]+)$/);
                const filterName = filterNameMatch ? filterNameMatch[1] : filterKey;

                const filterValue = activeFilters[filterKey];

                // Handle array values (checkboxes)
                if (Array.isArray(filterValue)) {
                    filterValue.forEach(item => {
                        const value = item.value || item;
                        const label = item.label || item.value || item;
                        // Use label if value is a GID
                        const isGID = typeof value === 'string' && value.startsWith('gid://shopify/');
                        const finalValue = isGID ? label : value;

                        filtersArray.push(`${filterName}:${finalValue}`);
                    });
                }
                // Handle single values (radio buttons, selects)
                else if (typeof filterValue === 'object' && filterValue !== null) {
                    const value = filterValue.value || '';
                    const label = filterValue.label || filterValue.value || '';
                    // Use label if value is a GID
                    const isGID = typeof value === 'string' && value.startsWith('gid://shopify/');
                    const finalValue = isGID ? label : value;

                    filtersArray.push(`${filterName}:${finalValue}`);
                }
                // Handle string values (fallback)
                else {
                    filtersArray.push(`${filterName}:${filterValue}`);
                }
            });
        }

        const customEvent = {
            event: "collections_filter_apply",
            filter_type: filterType || "unknown",
            filter_data: filterData || {},
            active_filters: filtersArray.join(' | '),
            results_count: resultsCount || 0,
            page_location: window.location.href,
            page_path: window.location.pathname
        };

        dataLayer.push(customEvent);
        console.log("dataLayer push -> collections_filter_apply:", customEvent);
    }

    handleGuideClick(event) {
        if (!dataLayer) return;

        const button = event.target.closest('[data-toggle-id]');
        if (!button) return;

        const toggleId = button.getAttribute('data-toggle-id');
        let eventName = '';
        let guideType = '';

        // Map toggle ID to event name and guide type
        switch(toggleId) {
            case 'pm-size-guide':
                eventName = 'product_sizeguide';
                guideType = 'size';
                break;
            case 'pm-lens-guide':
                eventName = 'product_lensguide';
                guideType = 'lens';
                break;
            case 'pm-strength-guide':
                eventName = 'product_strengthguide';
                guideType = 'strength';
                break;
            default:
                return;
        }

        const customEvent = {
            event: eventName,
            guide_type: guideType,
            page_location: window.location.href,
            page_path: window.location.pathname
        };

        dataLayer.push(customEvent);
        console.log(`dataLayer push -> ${eventName}:`, customEvent);
    }

    handleCartUpsellImageClick(event) {
        if (!dataLayer) return;

        const image = event.target;
        const link = image.closest('a.pc__wrapper-link');

        if (!link) return;

        // Extract product information
        const productUrl = link.getAttribute('href') || '';
        const productTitle = link.querySelector('.pc__information__title')?.textContent.trim() || '';

        // Try to get GTM select settings if available
        let productData = {};
        const selectSettings = link.getAttribute('data-select-settings');
        if (selectSettings) {
            try {
                const settings = JSON.parse(selectSettings);
                productData = {
                    item_id: settings.item_id || '',
                    item_name: settings.item_name || productTitle,
                    price: settings.price || 0,
                    item_brand: settings.item_brand || '',
                    list_id: settings.list_id || 'cart_recommendations',
                    list_name: settings.list_name || 'Cart Recommendations'
                };
            } catch (e) {
                console.log('Could not parse select settings', e);
                productData = {
                    item_name: productTitle,
                    list_id: 'cart_recommendations',
                    list_name: 'Cart Recommendations'
                };
            }
        } else {
            productData = {
                item_name: productTitle,
                list_id: 'cart_recommendations',
                list_name: 'Cart Recommendations'
            };
        }

        const customEvent = {
            event: 'cart_upsell_module_image',
            product_url: productUrl,
            ...productData,
            page_location: window.location.href,
            page_path: window.location.pathname
        };

        dataLayer.push(customEvent);
        console.log('dataLayer push -> cart_upsell_module_image:', customEvent);
    }

    handleCartUpsellAddToCart(event) {
        if (!dataLayer) return;

        const button = event.target.closest('.pc__instant-atc');
        if (!button) return;

        // Get product URL from button
        const productUrl = button.getAttribute('data-product-url') || '';

        // Get product card wrapper to extract product info
        const productCard = button.closest('product-card');
        if (!productCard) return;

        const link = productCard.querySelector('a.pc__wrapper-link');
        const productTitle = productCard.querySelector('.pc__information__title')?.textContent.trim() || '';

        // Try to get GTM select settings if available
        let productData = {};
        if (link) {
            const selectSettings = link.getAttribute('data-select-settings');
            if (selectSettings) {
                try {
                    const settings = JSON.parse(selectSettings);
                    productData = {
                        item_id: settings.item_id || '',
                        item_name: settings.item_name || productTitle,
                        price: settings.price || 0,
                        item_brand: settings.item_brand || '',
                        list_id: settings.list_id || 'cart_recommendations',
                        list_name: settings.list_name || 'Cart Recommendations'
                    };
                } catch (e) {
                    console.log('Could not parse select settings', e);
                    productData = {
                        item_name: productTitle,
                        list_id: 'cart_recommendations',
                        list_name: 'Cart Recommendations'
                    };
                }
            } else {
                productData = {
                    item_name: productTitle,
                    list_id: 'cart_recommendations',
                    list_name: 'Cart Recommendations'
                };
            }
        } else {
            productData = {
                item_name: productTitle,
                list_id: 'cart_recommendations',
                list_name: 'Cart Recommendations'
            };
        }

        const customEvent = {
            event: 'cart_upsell_module_atc',
            product_url: productUrl,
            ...productData,
            page_location: window.location.href,
            page_path: window.location.pathname
        };

        dataLayer.push(customEvent);
        console.log('dataLayer push -> cart_upsell_module_atc:', customEvent);
    }

    buildEcommerce(cartItems) {
        const items = [];
        let totalPrice = 0;        

        cartItems.forEach((item) => {            
            const price = typeof item.price === "number" ? item.price / 100 : Number(item.price);
            totalPrice += price * item.quantity;
            
            const product = {
                'item_id': item.sku || "",
                'item_name': item.untranslated_product_title || item.title || "",
                'item_variant': item.untranslated_variant_title || "Default Title",
                'price': price, 
                'quantity': item.quantity,
                'category': item.properties?.["_gtm-category"] || "",
                'category2': item.properties?.["_gtm-category2"] || "",
                'item_brand': item.properties?.["_gtm-item_brand"] || "",
                'list_id': item.properties?.["_gtm-list_id"] || "",
                'list_name': item.properties?.["_gtm-list_name"] || ""
            }

            items.push(product);
        });

        return {
            'value': totalPrice,
            'currency': ShopifyAnalytics.meta.currency,
            'items': items
        }
    }

    getDataFromRequest(cartItems, request) {
        let body = request?.body || null;
        if (!body) return cartItems;
        body = JSON.parse(body);
        console.log(body);
        const quantity = body["quantity"] || 1;
        if (quantity) cartItems[0].quantity = Number(quantity);

        return cartItems;
    }
}

new gTagEvents();